const { shortenCompanyName } = require('./text')

function getUserDisplayName(user = {}) {
    const settings = user.settings || {}
    const companyName = settings.organization ? shortenCompanyName(settings.organization) : ''
    const personalName = [settings.lastName, settings.firstName, settings.patronymic]
        .filter(Boolean)
        .join(' ')

    return companyName
        || personalName
        || user.displayName
        || user.username
        || user.login
        || ''
}

module.exports = { getUserDisplayName }
